import React from 'react'
import HeroSlider from '../Components/HeroSlider/HeroSlider'
import './Styles/Shop.css'
import Popular from '../Components/Popular/Popular'
import NewCollection from '../Components/NewCollection/NewCollection'
import CategoryCards from '../Components/CategoryCards/CategoryCards'

const Shop = () => {
  return (
    <div>
      <HeroSlider/>
      <CategoryCards/>
      <NewCollection/>
      <Popular/>
    </div>
  )
}

export default Shop